import { Component, OnInit } from '@angular/core';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { DriveService } from 'src/app/services/drive/drive.service';
import { SearchService } from 'src/app/services/search/search.service';
import { AddHiringDriveComponent } from '../add-hiring-drive/add-hiring-drive.component';
import { MatDialog } from '@angular/material';
import { WalkinDriveDialogboxComponent } from '../walkin-drive-dialogbox/walkin-drive-dialogbox.component';

@Component({
  selector: 'app-drive-dashboard-v2',
  templateUrl: './drive-dashboard-v2.component.html',
  styleUrls: ['./drive-dashboard-v2.component.scss']
})
export class DriveDashboardV2Component implements OnInit {
  cards: any;
  toBeSearched: string;
  selectedIndex: string;

  constructor(private utitlity: UtilityService,
    private driveService: DriveService,
    private searchService: SearchService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.getCards();
    if (localStorage.getItem('indexForDrive') === null) {
      this.selectedIndex = '0';
      console.log("Selected index", this.selectedIndex);

    } else {
      this.selectedIndex = localStorage.getItem('indexForDrive');
      console.log("Selected index", this.selectedIndex);

    }
    if (localStorage.getItem('tabValueForDrive') === null) {
      localStorage.setItem('tabValueForDrive', 'WALKIN');
      this.getData('WALKIN');
    } else {
      this.getData(localStorage.getItem('tabValueForDrive'));
      // localStorage.setItem('tabValueForDrive', localStorage.getItem('tabValueForDrive'));
    }
  }

  getData(DriveType) {
    console.log("Drive type:", DriveType);
  }

  getCards() {
    this.utitlity.showSpinner();
    this.driveService.getDriveList().subscribe(
      response => {
        this.cards = (response as any).data;
        this.cards = this.cards.reverse();
        this.searchService.currentMessage.subscribe(
          response1 => {
            this.toBeSearched = response1;
            this.utitlity.hideSpinner();
          });
        console.log('_____________', this.cards);
      }
    );
  }

  openAddHiringDrive(): void {
    const dialogRef = this.dialog.open(AddHiringDriveComponent, {
      disableClose: true,
      panelClass: "dialog-style",
      //width: '50em',
      //height: '38em'
      //height: 'fit-content'
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed' , result);
      if (result)
        this.getCards();
    });
  }

  openWalkinDrive(): void {
    const dialogRef = this.dialog.open(WalkinDriveDialogboxComponent, {
      disableClose: true,
      panelClass: "dialog-style"
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result)
        console.log("Result in openWalkinDrive:", result);
    });
  }

  selectTab(event) {
    if (event.index === 0) {
      localStorage.setItem('tabValueForDrive', 'WALKIN');
      localStorage.setItem('indexForDrive', event.index);
      this.selectedIndex = event.index;
      this.getData('WALKIN');
    }
    else {
      localStorage.setItem('tabValueForDrive', 'INSTITUTION');
      localStorage.setItem('indexForDrive', event.index);
      this.selectedIndex = event.index;
      this.getData('INSTITUTION');
    }
  }
}
